import SuperJSON from "superjson";
import Id from "../types/Id";

export default class ApiKeyId extends Id<"apiKey"> {}

SuperJSON.registerClass(ApiKeyId);
